import React from "react";
import { Link } from "react-router-dom";

// NOTE: Import your actual logos here

// import logo2 from "../../assets/logo2.png";
// import logo3 from "../../assets/logo3.png";
// import logo4 from "../..assets/logo4.png";
// import logo1 from "../../assets/logo1.png";
import YarqinMirzad from "../../assets/ym.png";
import TechLogo from "../../assets/teclogo.jpg";

const CompanyPartners = () => {
  const partners = [
    {
      id: 1,
      name: "IT Park Uzbekistan",
      //   src: logo1,
      src: "https://outsource.gov.uz/_next/static/media/logo.fd681f09.svg", // Placeholder
    },
    {
      id: 2,
      name: "Yarqin Mirzad ISP",
      // src: logo2,
      src: YarqinMirzad, // Placeholder
    },
    {
      id: 3,
      name: "Partner C",
      // src: logo3,
      src: TechLogo, // Placeholder
    },
    {
      id: 4,
      name: "Partner D",
      // src: logo4,
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/IBM_logo.svg/200px-IBM_logo.svg.png", // Placeholder
    },
  ];

  return (
    <section className="py-20 bg-slate-50 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid Layout: 12 Columns (7 for logos, 5 for text on desktop) */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12">
          {/* --- Left Side: Logos Section (7 columns) --- */}
          <div className="md:col-span-7">
            <div className="bg-white p-8 lg:p-10 rounded-2xl shadow-sm border border-slate-100">
              <h2 className="text-3xl font-extrabold text-slate-900 mb-8 text-center">
                Companies We Work With
              </h2>

              {/* Logos Grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 items-center">
                {partners.map((partner) => (
                  <div
                    key={partner.id}
                    className="flex items-center justify-center h-24 md:h-32 bg-slate-50 rounded-xl hover:bg-white hover:shadow-md transition-all duration-300 group border border-slate-100"
                  >
                    <img
                      src={partner.src}
                      alt={partner.name}
                      // object-contain ensures the logo keeps its aspect ratio without stretching
                      className="h-12 md:h-16 w-auto object-contain opacity-70 grayscale group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* --- Right Side: Text Content (5 columns) --- */}
          <div className="md:col-span-5 flex flex-col justify-center">
            {/* Badge */}
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold tracking-wide uppercase mb-4 w-max">
              Strategic Partners
            </span>

            <h3 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-6">
              Building Alliances for <br />
              <span className="text-blue-600">Future Success</span>
            </h3>

            {/* Replaced Lorem Ipsum with meaningful content */}
            <p className="text-slate-600 text-lg leading-relaxed font-light">
              We are proud to collaborate with leading government agencies and
              private enterprises. These strategic partnerships allow us to
              deliver integrated solutions that meet the highest standards of
              security and reliability, fostering an ecosystem of innovation
              across the region.
            </p>

            {/* CTA Link */}
            <Link
              to="/contact"
              className="inline-flex items-center text-blue-600 font-bold mt-6 group"
            >
              Become a Partner
              <svg
                className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                ></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyPartners;
